import { useAppSelector } from '@Hooks/index';
import { currentUserSelector } from '@Store/selectors/userInfoSelector';

import styles from './component-styles.module.css';

const Greeting: React.FC = () => {
  const currentUser = useAppSelector(currentUserSelector);
  return (
    <div className={styles.greetingSection}>
      <div className={styles.greetText}>Hello,</div>
      <div className={styles.userName}>{currentUser.empName}</div>
    </div>
  );
};

export default Greeting;
